<template>
    <div class="sheet-content">
        <div class="sheet-top">
            <div class="sheet-title">数据编辑</div>
            <div class="sheet-close" @click="closeSheet">
                <img src="../assets/sheet-close.png" class="sheet-close-img" alt="">
            </div>
        </div>
        <div class="sheet-center">
            <div class="button-group">
                <div :class="{button1: true, active: isApi}" @click="dataExcel">Excel数据编辑</div>
                <div :class="{button1: true, active: !isApi}" @click="dataApi">API接入</div>
                <!-- <div class="button1">智能导入</div> -->
            </div>
            <div id="luckysheet" class="luckysheet-wrap" v-show="!isApi">
            </div>
            <div class="api-content" v-show="isApi">
                <div class="left-content">
                    <div class="api-item">
                        <div class="api-text">api地址：</div>
                        <div class="item-right">
                            <el-input type="text" v-model="apiurl" placeholder="请输入API地址"></el-input>
                        </div>
                    </div>
                    <div class="api-item">
                        <div class="api-text">获取方法：(get/post)</div>
                        <div class="item-right">
                            <el-input type="text" v-model="apimeth" placeholder="请输入获取方法"></el-input>
                        </div>
                    </div>
                    <div class="api-item">
                        <div class="api-text">请求头：</div>
                        <div>
                            <div class="item-right" v-for="(item, i) in apiheader" :key="i">
                                <el-input v-model="item.key" placeholder="请输入携带请求头名称"></el-input>
                                <el-input v-model="item.value" placeholder="请输入携带请求头数值"></el-input>
                                <div class="api-btn" :class="{del: i < apiheader.length - 1}" @click="addheader(i)">
                                    <img :src="i == apiheader.length - 1 ? add : del" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="api-item">
                        <div class="api-text">请求参数：</div>
                        <div>
                            <div class="item-right" v-for="(item, i) in apiparams" :key="i">
                                <el-input v-model="item.key" placeholder="请输入携带请求参数名称"></el-input>
                                <el-input v-model="item.value" placeholder="请输入携带请求参数数值"></el-input>
                                <div class="api-btn" :class="{del: i < apiparams.length - 1}" @click="addparams(i)">
                                    <img :src="i == apiparams.length - 1 ? add : del" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="api-item">
                        <div class="api-text">请求频率：（频率为0时不自动请求，单位：秒）</div>
                        <div class="item-right">
                            <el-input v-model="frequ" type="number"></el-input>
                        </div>
                    </div>
                    <div class="api-item">
                        <div class="api-text">与其他接口联动</div>
                        <div class="api-switch">
                            <el-switch
                                v-model="iscontact"
                                active-color="#3B89FF"
                                inactive-color="#C9C9C9">
                            </el-switch>
                            ({{ iscontact ? '已开启' : '已关闭' }})
                        </div>
                    </div>
                    <div class="api-item special-item">
                        <div class="api-text">
                            API状态：
                        </div>
                        <div class="api-switch">
                            <el-switch
                                v-model="openapi"
                                active-color="#3B89FF"
                                inactive-color="#C9C9C9"
                                @change="apichange">
                            </el-switch>
                            ({{ openapi ? '已开启' : '已关闭' }})(API打开状态下，Excel配置无效)
                        </div>
                    </div>
                </div>
                <div class="right-content">
                    <div class="api-item">
                        <div class="api-text">示例：
                            <el-tooltip class="item" effect="dark" placement="top">
                                <div class="tips-icon"></div>
                                <div v-html="tipsContent" slot="content" class="tips-content"></div>
                            </el-tooltip>
                        </div>
                        <div class="data-example" v-html="example">
                        </div>
                    </div>
                    <div class="api-item">
                        <div class="api-text">数据响应结果：（数据取值为接口的res.data.data）</div>
                        <div class="data-show">
                            {{ result }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sheet-foot">
            <div class="foot-group" v-if="!isApi">
                <div class="foot-text">
                    <el-switch
                        v-model="openmore"
                        active-color="#3B89FF"
                        inactive-color="#C9C9C9"
                        @change="morechange">
                    </el-switch>
                    {{ openmore ? '弹窗功能已开启' : '开启弹窗功能' }}（开启后弹窗展示内容为Sheet2内容）
                </div>
                <el-button class="first-btn" type="primary" v-show="!sheetloading" @click="exportJson" size="small">确认提交</el-button>
                <el-button type="info" v-show="!sheetloading" @click="closeSheet" size="small">取消</el-button>
            </div>
            <div class="foot-group" v-if="isApi">
                <el-button class="first-btn" type="success" @click="getApi" size="small">获取数据</el-button>
                <el-button type="primary" @click="exportJson" size="small">确认提交</el-button>
                <el-button type="info" @click="closeSheet" size="small">取消</el-button>
            </div>
        </div>
		<paylog :payvisible="payvisible" @payclose="payclose"></paylog>
    </div>
</template>

<script>
import axios from 'axios'
import add from '@/assets/icon-add.png'
import del from '@/assets/icon-del.png'
import paylog from '@/components/paylog.vue'

export default {
    components: {
        paylog
    },
    props: {
        vdata: {
            type: Array,
            default: () => []
        },
        isexcel: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            default: () => {}
        },
        isapi: {
            type: Boolean,
            default: false
        },
        apidata: {
            type: Object,
            default: () => {}
        },
        selectcope: {
            type: Object,
            default: () => {}
        },
        showcontact: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            add,
            del,
            isApi: false,
            options: {
                container: 'luckysheet', // DOM容器的ID
                lang: 'zh', // 设定表格的语言
                data: [
                    {
                        name: "Sheet1",
                        color: "#eee",
                        status: "1",
                        order: "0",
                        data: [],
                    }
                ],
            },
            sheetData: [
                {"年级":"","姓名":"","学号": "","年龄": "","籍贯":"","成绩": ""},
                // {"年级":"初一","姓名":"李四","学号":7142,"年龄":18,"籍贯":"河北","成绩":79},
                // {"年级":"初二","姓名":"王五","学号":7143,"年龄":19,"籍贯":"河北","成绩":80},
                // {"年级":"初三","姓名":"李华","学号":7144,"年龄":20,"籍贯":"山东","成绩":81},
                // {"年级":"初一","姓名":"赵国","学号":7145,"年龄":21,"籍贯":"河北","成绩":82},
                // {"年级":"初一","姓名":"李青","学号":7146,"年龄":22,"籍贯":"河北","成绩":83},
                // {"年级":"初三","姓名":"王国","学号":7147,"年龄":23,"籍贯":"山西","成绩":84},
                // {"年级":"初一","姓名":"正东","学号":7148,"年龄":24,"籍贯":"四川","成绩":85},
                // {"年级":"初二","姓名":"钱多","学号":7149,"年龄":25,"籍贯":"河北","成绩":86},
                // {"年级":"初一","姓名":"付丽","学号":7150,"年龄":26,"籍贯":"贵州","成绩":87}
            ],
            sheetfile: {},
            sheetloading: true,
            apiurl: '',
            apimeth: '',
            apiheader: [
                {key: '', value: ''}
            ],
            apiparams: [
                {key: '', value: ''}
            ],
            result: '',
            openapi: false,
            frequ: 0,
            example: '',
            tipsContent: '',
            valuemap: {},
            openmore: false,
			payvisible: false,
            iscontact: false
        }
    },
    methods: {
        setdata() {
            this.sheetData = this.vdata
            if (this.apidata) {
                const { method, url, headers, data, params, frequ, iscontact } = this.apidata
                method && (this.apimeth = method)
                url && (this.apiurl = url)
                this.frequ = frequ || 0
                this.iscontact = iscontact || false
                if (headers && Object.keys(headers).length) {
                    this.apiheader = []
                    headers && Object.keys(headers).forEach(item => {
                        this.apiheader.push({key: item, value: headers[item]})
                    })
                }
                if ((data && Object.keys(data)) || (params && Object.keys(params))) {
                    this.apiparams = []
                    data && Object.keys(data).forEach(item => {
                        this.apiparams.push({key: item, value: data[item]})
                    })
                    params && Object.keys(params).forEach(item => {
                        this.apiparams.push({key: item, value: params[item]})
                    })
                }
                this.openapi = this.isapi
            }
            this.createSheet()
        },
        createSheet () {
            const _this = this
            if (this.isexcel && this.vdata.length && this.vdata[0].luckysheet_select_save) {
                // 初始化表格
                this.options.data = [...this.vdata]
                let selectdata = this.vdata.find(item => item.status == 1)
                this.options.hook = {
                    workbookCreateAfter: function() {
                        _this.sheetloading = false
                        selectdata.data.forEach((item, i) => {
                            item.forEach((del, a) => {
                                if (del && del.f) {
                                    luckysheet.setCellValue(i, a, {f: del.f})
                                }
                            })
                        })
                    }
                }
                luckysheet.create(this.options)
            } else {
                this.sheetData = this.vdata
                // 初始化表格
                this.options.hook = {
                    workbookCreateAfter: function() {
                        _this.sheetloading = false
                        _this.importJson(_this.sheetData)
                    }
                }
                luckysheet.create(this.options)
            }
        },
        closeSheet() {
            luckysheet.destroy()
            this.$emit('closeSheet')
        },
        importJson (data) {
            let range = luckysheet.getRange()
            let row = range[0].row[0]
            let column = range[0].column[0]
            if (data.length > 0) {
                let keys = Object.keys(data[0])
                keys.forEach((item, index) => {
                    luckysheet.setCellValue(row, column + index, item)
                })
            }
            data.forEach((item1, index1) => {
                let values = Object.values(item1)
                values.forEach((item2, index2) => {
                    luckysheet.setCellValue(row + 1 + index1, column + index2, item2)
                })
            })
        },
        exportJson () {
            let exceldata = luckysheet.getAllSheets()
            let sheetdata = luckysheet.getAllSheets()[0].data
            let jsondata = sheetdata.filter(item => {
                return item.filter(del => del).length
            })
            let newdata = []
            let headdata = jsondata[0].filter(item => item).map(del => {
                return del.m
            })
            jsondata.shift()
            jsondata.forEach(item => {
                let ondata = {}
                headdata.forEach((del, i) => {
                    if(item[i]) {
                        ondata[del] = item[i].m
                    }
                })
                newdata.push(ondata)
            })
            if (this.openmore) {
                if (exceldata.length > 1) {
                    let logdata = exceldata[1].data
                    logdata = logdata.map(item => {
                        let newitem = item.filter(item => item).map(del => {
                            return del.m
                        })
                        return newitem
                    })
                    logdata = logdata.filter(item => item && item.length)
                    this.$emit('moredata', logdata)
                } else {
                    this.$emit('moredata', [])
                }
            } else {
                this.$emit('moredata', [])
            }
            luckysheet.destroy()
            let config = this.getparams()
            console.log('____aaaapi', config)
            this.$emit('closeSheet', newdata, exceldata, config, this.openapi)
        },
        dataExcel() {
            if (!this.isApi) return
            this.isApi = false
            // this.$nextTick(() => {
            //     this.createSheet()
            // })
        },
        dataApi() {
            if(this.isApi) return
            // luckysheet.destroy()
            this.isApi = true
        },
        getApi() {
            let config = this.getparams()
            axios(config).then(res => {
                this.result = res.data.data
            })
        },
        addheader(i) {
            if(i == this.apiheader.length - 1) {
                let newheader = {key: '', value: ''}
                this.apiheader.push(newheader)
            } else {
                this.apiheader.splice(i, 1)
                this.apiheader = [...this.apiheader]
            }
        },
        addparams(i) {
            if(i == this.apiparams.length - 1) {
                let newparams = {key: '', value: ''}
                this.apiparams.push(newparams)
            } else {
                this.apiparams.splice(i, 1)
                this.apiparams = [...this.apiparams]
            }
        },
        getparams() {
            let headers = {}
            this.apiheader.forEach(item => {
                if (item.key == '') return
                headers[item.key] = item.value
            })
            let params = {}
            this.apiparams.forEach(item => {
                if (item.key == '') return
                params[item.key] = item.value
            })
            let nparams = {}
            if (this.apimeth == 'get') {
                nparams.params = params
            } else {
                nparams.data = params
            }
            let config = {
                method: this.apimeth,
                url: this.apiurl,
                headers: {
                    ...headers
                },
                frequ: this.frequ,
                iscontact: this.iscontact,
                ...nparams
            }
            return config
        },
        async morechange(e) {
            this.openmore = false
            if (e == true) {
                if (!await this.getPermision(2)) {
                    return;
                } else {
                    this.openmore = true
                }
            }
        },
        async apichange(e) {
            this.openapi = false
            if (e == true) {
                if (!await this.getPermision(2)) {
                    return;
                } else {
                    this.openapi = true
                }
            }
        },
        // 关闭升级弹窗
        payclose() {
            this.payvisible = false
        }
    },
    watch: {
        vdata(n) {
            this.setdata()
        },
        isapi(n) {
            console.log('___isapi', n)
            this.openapi = n
        },
        apidata(n) {
            this.setdata()
        },
        selectcope(n) {
            this.valuemap = n.valueMap
            if (n.vdata && n.vdata.length) {
                this.example = '[' + n.vdata[0] + ']'
            }
        }
    },
    mounted() {
        this.setdata()
        if (this.selectcope) {
            if (this.selectcope.vdata && this.selectcope.vdata.length) {
                this.example = '[<br/>' + JSON.stringify(this.selectcope.vdata[0]) + '<br/>]'
            } else {
                let exam = this.selectcope.jsondata[0]
                let newmap = {}
                this.selectcope.valueMap.forEach(item => {
                    newmap[item.key] = exam[item.name]
                })
                this.example = '[<br/>' + JSON.stringify(newmap) + '<br/>]'
            }
            if (this.selectcope.valueMap && this.selectcope.valueMap.length) {
                let content = ''
                this.selectcope.valueMap.forEach(item => {
                    let text = item.key + '：指代' + item.name + '，文本型<br/>'
                    content += text
                })
                this.tipsContent = '字段说明：<br/>' + content
            }
            this.openmore = this.selectcope.ismore 
        }
    }
}
</script>

<style scoped lang="scss">
.sheet-content {
    position: relative;
    width: 100%;
    height: 100%;
}
.sheet-top {
    width: 100%;
    height: 54px;
    background: #F1F3F4;
    display: flex;
    align-items: center;
}
.sheet-title {
    margin-left: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #1E1E1E;
    line-height: 23px;
}
.luckysheet-wrap {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 504px;
}
.api-content {
    padding: 16px 0 24px;
    border-top: 1px solid #E7E7E7;
    width: 100%;
    height: 462px;
    display: flex;
    position: relative;
    border-bottom: 1px solid #E7E7E7;
    .left-content {
        width: calc(50% - 20px);
        height: calc(100% - 50px);
        padding-right: 20px;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background: #0089FF;
        }
        &::-webkit-scrollbar-track {
            background: #E9E9E9;
        }
        .item-right {
            margin-top: 16px;
            display: flex;
            align-items: center;
            column-gap: 12px;
            & + .item-right {
                margin-top: 8px;
            }
        }
    }
    .api-switch {
        margin-top: 6px;
    }
    .right-content {
        width: calc(50% - 20px);
        padding-left: 20px;
        height: 100%;
    }
    .api-text {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #262C33;
        line-height: 26px;
        display: flex;
        align-items: center;
        .tips-icon {
            width: 14px;
            height: 14px;
            transition: all 0.3s linear;
            cursor: pointer;
            background: url(@/assets/tips-default.png);
            background-size: 100% 100%;
            &:hover {
                background: url(@/assets/tips-active.png);
                background-size: 100% 100%;
            }
        }
    }
    .data-show {
        margin-top: 16px;
        width: 418px;
        height: 180px;
        border-radius: 5px;
        border: 1px solid #DBDFE5;
        padding: 16px;
        max-height: 180px;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 0;
        }
    }
    .data-example {
        margin-top: 16px;
        width: 418px;
        height: 110px;
        border-radius: 5px;
        border: 1px solid #DBDFE5;
        padding: 16px;
        max-height: 110px;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 0;
        }
    }
    .api-item {
        margin-bottom: 24px;
        &.special-item {
            margin-top: 0;
            position: absolute;
            bottom: 0;
            left: 0;
        }
    }
    .api-btn {
        width: 50px;
        min-width: 50px;
        height: 40px;
        background: #0089FF;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &.del {
            background: #FF6767;
        }
        img {
            width: 14px;
            height: 14px;
        }
    }
}
.sheet-center {
    padding: 0 32px 24px;
    height: 556px;
    display: block;
    background-color: #fff;
    .button-group {
        display: flex;
        align-items: center;
        margin: 16px 0;
        column-gap: 16px;
    }
    .button1 {
        width: 134px;
        text-align: center;
        cursor: pointer;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        padding: 10px 0;
        border-radius: 4px;
        transition: all 0.2s linear;
        background: #0089FF;
        border: 1px solid #0089FF;
        color: #fff;
        
        &:hover {
            background: #66b1ff;
            color: #fff;
        }
        &.active {
            background: #F7F8FA;
            border: 1px solid #EDEEEF;
            color: #313131;
        }
    }
}
.sheet-foot {
    padding: 0 32px;
    height: fit-content;
    background: #fff;
}
.foot-text {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #949494;
    line-height: 14px;
}
.foot-group {
    display: flex;
    width: fit-content;
    margin: 0 12px 0 0;
    padding: 0 0 24px;
    column-gap: 6px;
    width: 100%;
    > .first-btn {
        margin-left: auto;
    }
}
.sheet-close {
    margin: -12px 32px 0 auto;
    height: 12px;
    width: 12px;
    .sheet-close-img {
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
}
.tips-content {
    font-size: 14px;
    line-height: 20px;
    padding: 10px 16px;
}
</style>